/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It normalises the raw count to a rate per 1000 codons, so you can compare codon usage between sequences of different lengths.`)
};

const es_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaliza el conteo bruto a una tasa por cada 1000 codones, para que puedas comparar el uso de codones entre secuencias de diferente longitud.`)
};

const de_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie normalisiert die Rohanzahl auf eine Rate pro 1000 Codons, sodass Sie die Codon-Nutzung zwischen Sequenzen unterschiedlicher Länge vergleichen können.`)
};

const nl_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het normaliseert het ruwe aantal naar een percentage per 1000 codons, zodat je het codongebruik tussen sequenties van verschillende lengte kunt vergelijken.`)
};

const fr_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle normalise le décompte brut en un taux pour 1000 codons, ce qui permet de comparer l'usage des codons entre séquences de longueurs différentes.`)
};

const it_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalizza il conteggio grezzo a un tasso per 1000 codoni, così puoi confrontare l'uso dei codoni tra sequenze di lunghezza diversa.`)
};

const pt_br2_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela normaliza a contagem bruta para uma taxa por 1000 códons, permitindo comparar o uso de códons entre sequências de comprimentos diferentes.`)
};

const pt_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaliza a contagem bruta para uma taxa por 1000 codões, permitindo comparar o uso de codões entre sequências de comprimentos diferentes.`)
};

const ja_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生のカウント数を1000コドンあたりの率に正規化したもので、異なる長さの配列間でコドン使用を比較できます。`)
};

const zh_codon_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它将原始计数标准化为每千个密码子的比率，从而可以比较不同长度序列之间的密码子使用情况。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_a2", locale)
	if (locale === "en") return en_codon_faq_a2(inputs)
	if (locale === "es") return es_codon_faq_a2(inputs)
	if (locale === "de") return de_codon_faq_a2(inputs)
	if (locale === "nl") return nl_codon_faq_a2(inputs)
	if (locale === "fr") return fr_codon_faq_a2(inputs)
	if (locale === "it") return it_codon_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_a2(inputs)
	if (locale === "pt") return pt_codon_faq_a2(inputs)
	if (locale === "ja") return ja_codon_faq_a2(inputs)
	return zh_codon_faq_a2(inputs)
};